// extracted by mini-css-extract-plugin
export default {"wrapper":"LearnersSearch_wrapper__sxD0x","icon":"LearnersSearch_icon__M8vFb","input":"LearnersSearch_input__Otdyw"};